// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3e43fed2","455":"dd47337a","977":"ea175591"}[chunkId] + ".chunk.js";
};